import { render, staticRenderFns } from "./SanityPosts.vue?vue&type=template&id=f2360532&"
import script from "./SanityPosts.vue?vue&type=script&lang=js&"
export * from "./SanityPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports